export default __webpack_public_path__ + "static/media/Settings_PenLineWidth.d1c73898.svg";